export const regex = {
    numbers: /^[0-9]+$/,
    numbersAndLetters: /^[0-9A-Za-z]+$/,
    email: /^.{1,30}@.{1,20}\..{1,10}$/
}
export const errorFree = (errors) => {
    const flattenErrors = JSON.flatten(errors);
    return !Object.values(flattenErrors)
        .some(error => {
            if (typeof(error) !== "boolean")
                return false;
            return error;
        });
};
export const handlerKeyPressOnlyNumbers = e => {
    if (!regex.numbers.test(e.key)) 
        e.preventDefault();
}
export const handlerKeyPressOnlyNumbersAndLetters = e => {
    if (!regex.numbersAndLetters.test(e.key)) 
        e.preventDefault();
}